import React, { useMemo } from "react";
import { ArrowRightIcon, CheckIcon, CreditCardIcon, FileTextIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { ProductMockup } from "./ProductMockup";
import { offerIncludes } from "../data/landing";
import { productBrief } from "../data/productBrief";
import { getCheckoutUrl } from "../utils/checkout";
export function OfferSection() {
  const checkoutUrl = useMemo(() => getCheckoutUrl(), []);
  const openLicenseFaq = () => {
    const item = document.getElementById("faq-license");
    if (item instanceof HTMLDetailsElement) item.open = true;
  };
  return <section className="section offer-section" id="offer-details" aria-labelledby="offer-heading" data-id="element-69" data-mp="rdmwbmovc7vq">
      <div className="shell" data-id="element-70" data-mp="wby9o7edh0ip">
        <div className="section-intro" data-id="element-71" data-mp="wc80fx78rbpg">
          <p className="eyebrow" data-id="element-72" data-mp="2t5jbd6a8vzv9">THE PLANNING IS ALREADY DONE</p>
          <h2 id="offer-heading" data-id="element-73" data-mp="2t7dwaklinrzc">
            Your next training sessions.
            <br data-id="element-74" data-mp="2y55o7em5ve3j" />
            <span data-id="element-75" data-mp="2y4mfmoiei226">Already planned for you.</span>
          </h2>
        </div>
        <div className="offer-grid" data-id="element-76" data-mp="12oa9kycxqdkt">
          <div className="offer-contents" data-id="element-77" data-mp="12pcyx1um07ym">
            <p className="eyebrow" data-id="element-78" data-mp="xwjqo3zxmhhs">VOLUME 1 · SALES CONVERSATION FOUNDATIONS</p>
            <h3 data-id="element-79" data-mp="sxfi9fku0nsi">{productBrief.brand}</h3>
            <p data-id="element-80" data-mp="sy8jk110ul39">
              The agendas, facilitator wording, role cards, examples and feedback sheets are already
              written. You get Volume 1 with five complete workshop plans, printable participant
              materials and five bonuses to organize the practice around them.
            </p>
            <h4 data-id="element-81" data-mp="1go2v8f9lu3lx">Your ready-to-run training plan includes</h4>
            <ul className="check-list" data-id="element-82" data-mp="1ckwsvipm4wkq">
              {offerIncludes.map(item => <li key={item} data-id="element-83" data-mp="17n4p9rflvm0p">
                  <CheckIcon size={18} aria-hidden="true" data-id="element-84" data-mp="17ltmnuxwckb6" />
                  {item}
                </li>)}
            </ul>
            <h4 data-id="element-85" data-mp="146hll6c1ek9">All five bonuses are included</h4>
            <ul className="bonus-checks" data-id="element-86" data-mp="3sbsp5ow6a16e">
              {productBrief.bonuses.map(bonus => <li key={bonus.number} data-id="element-87" data-mp="3tv13yfmvt56z">
                  <CheckIcon size={16} aria-hidden="true" data-id="element-88" data-mp="3trwr6tvcp14p" />
                  {bonus.title}
                </li>)}
            </ul>
          </div>

          <div className="price-card" data-id="element-89" data-mp="3ks9rqdm6m5ea">
            <ProductMockup data-id="element-90" data-mp="3kve0zpei7rbt" />
            <p className="price-caption" data-id="element-91" data-mp="3oumviwhdbt8f">VOLUME 1 · 5 WORKSHOPS + 5 BONUSES</p>
            <p className="offer-price" data-id="element-92" data-mp="3owr9k78ze8mf">
              <span data-id="element-93" data-mp="3b38dosz75y2y">${productBrief.price.amountUsd}</span> USD
            </p>
            <p className="payment-note" data-id="element-94" data-mp="3ftyia3zstwwl">One-time payment. No subscription.</p>
            <CtaButton href={checkoutUrl} data-id="element-95" data-mp="3fw1i1fqr74ei">
              Get my complete training plan <ArrowRightIcon size={18} aria-hidden="true" data-id="element-96" data-mp="31759ziop5rdw" />
            </CtaButton>
            <div className="delivery-details" data-id="element-97" data-mp="3656tg4q1bspw">
              <p data-id="element-98" data-mp="2s4nlsypheoo9">
                <CreditCardIcon size={17} aria-hidden="true" data-id="element-99" data-mp="2s445tnje6acv" />
                Continue to the Impul store checkout
              </p>
              <p data-id="element-100" data-mp="2x2fh82pc4sx7">
                <FileTextIcon size={17} aria-hidden="true" data-id="element-101" data-mp="2x2xmfotz6hh9" />
                English PDFs + printable participant pages
              </p>
            </div>
            <p className="format-note" data-id="element-102" data-mp="28jnh4zfvqp5z">
              {productBrief.status}
              <br data-id="element-103" data-mp="2middgcuvkkta" />
              Internal-team use. No video, slides, editable templates, software, certification or
              resale rights.
            </p>
            <a className="license-link" href="#faq-license" onClick={openLicenseFaq} data-id="element-104" data-mp="2ifqhbzr68dqa">
              Read format and license FAQs
            </a>
          </div>
        </div>
      </div>
    </section>;
}